.formContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
  margin: 1rem 0 1rem 0;
}

.inputGroup {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0.5rem;
  width: 100%;
}

.inputContainer {
  width: 100%;
}

.input {
  width: 100%;
}

.productTitle {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-left: 1ch;
}

.invalidText {
  color: var(--sentiment-text-negative);
}

.conditionNotesLabel {
  margin-bottom: 10px;
}

.addItemErrorAlert {
  margin-bottom: 10px;
}

.space {
  padding-bottom: 1rem;
}

.navigate {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

.submitButton {
  padding: 0.5rem 1rem !important;
  width: 100%;
}

.checkListContainer {
  margin: 1rem 0;
}